module.exports = __webpack_public_path__ + "essentialSkills-704ae76b9b5f8d042df5e9e16476ecaf.svg";